import type { RenderQualityConfig } from "../render/types.ts";

/** Bound streaming uploads independently of the normal gameplay draw. */
export const STREAMING_UPLOAD_CONFIG = Object.freeze({
  maximumMeshesPerFrame: 16,
});

export const RENDER_QUALITY_CONFIG: RenderQualityConfig = Object.freeze({
  maxPixelRatio: 1,
  shadowMapSize: 2048,
});
